import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IReactSelectOptionObject } from "@atman/business";
import { MultiValueRemoveProps } from "react-select/src/components/MultiValue";
import { components } from "react-select";

export interface IIconMultiValueRemoveProps<TValue = IReactSelectOptionObject> extends MultiValueRemoveProps<TValue> {}

export const IconMultiValueRemove: React.FC<IIconMultiValueRemoveProps> = (props) => {
    const { children, ...otherProps } = props;

    return (
        <components.MultiValueRemove {...otherProps}>
            <FontAwesomeIcon icon={["far", "times"]} />
        </components.MultiValueRemove>
    );
};
